import React from 'react';
import { Bell, ChevronRight } from 'lucide-react';

/**
 * Transit Alerts Panel — upcoming sign + nakshatra change events.
 *
 * Props:
 *   - alerts: transits.alerts array (already sorted by days_until)
 */

function fmtRemaining(days) {
  if (days < 1) {
    const hrs = Math.floor(days * 24);
    return `${hrs} घंटे शेष`;
  }
  if (days < 7) {
    return `${Math.floor(days)} दिन ${Math.floor((days % 1) * 24)} घंटे शेष`;
  }
  if (days < 60) {
    return `${Math.floor(days)} दिन शेष`;
  }
  const m = Math.floor(days / 30);
  return `${m} माह ${Math.floor(days - m * 30)} दिन शेष`;
}

const TYPE_LABEL = {
  sign_change: '➜ राशि परिवर्तन',
  nakshatra_change: '✦ नक्षत्र परिवर्तन',
};

export default function TransitAlerts({ alerts = [] }) {
  if (!alerts || alerts.length === 0) {
    return <div className="text-sm text-text-muted">कोई आगामी घटना नहीं</div>;
  }

  return (
    <div data-testid="transit-alerts" className="space-y-2">
      <div className="flex items-center gap-2 mb-3">
        <Bell className="w-4 h-4 text-gold" />
        <h4 className="text-sm font-heading text-gold">आगामी ग्रह घटनाएँ</h4>
      </div>
      {alerts.map((a, i) => (
        <div
          key={i}
          data-testid={`alert-${i}`}
          className="rounded-xl border border-gold/20 bg-gradient-to-r from-purple-950/40 via-bg-primary to-purple-950/40 p-3 hover:border-gold/40 transition-all"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-xs px-2 py-0.5 rounded-full bg-gold/15 border border-gold/30 text-gold font-semibold whitespace-nowrap">
                {TYPE_LABEL[a.event_type] || a.event_type}
              </span>
              <div className="min-w-0">
                <div className="font-heading text-gold text-base truncate">
                  {a.planet_hi} <span className="text-text-muted text-xs font-normal">{a.from_label} → {a.to_label}</span>
                </div>
                <div className="text-xs text-text-muted font-mono mt-0.5">{a.datetime_ist}</div>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-sm font-semibold text-gold">{fmtRemaining(a.days_until)}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
